"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateProgressBar = updateProgressBar;
function updateProgressBar(progress) {
    const progressFill = document.getElementById('progress-fill');
    if (progressFill) {
        const clampedProgress = Math.max(0, Math.min(100, progress));
        progressFill.style.width = `${clampedProgress}%`;
    }
}
